"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaInput = exports.Symbol = exports.InputWrapper = exports.Input = exports.InputStyles = exports.errorVariant = exports.sizeVariants = void 0;
const lodash_1 = require("lodash");
const react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
const stitches_config_1 = require("../../../stitches.config");
exports.sizeVariants = {
    //anything smaller than 16px/body2 will autozoom into the input on safari
    smaller: {
        fontSize: stitches_config_1.fontSizes.body3,
        padding: "0 12px",
        lineHeight: "28px",
    },
    small: {
        fontSize: stitches_config_1.fontSizes.body2,
        padding: "0 12px",
        lineHeight: "32px",
    },
    medium: {
        fontSize: stitches_config_1.fontSizes.body2,
        padding: "0 16px",
        lineHeight: "40px",
    },
    large: {
        fontSize: stitches_config_1.fontSizes.body2,
        padding: "0 16px",
        lineHeight: "48px",
    },
};
exports.errorVariant = {
    true: {
        borderColor: stitches_config_1.colors.borderUiCritical,
    },
};
exports.InputStyles = {
    width: "100%",
    borderRadius: stitches_config_1.cornerRadius.radiusSm,
    border: stitches_config_1.borderStyles.solid,
    color: stitches_config_1.colors.contentPrimary,
    "@media print": {
        display: "none",
    },
    "&:focus": {
        outline: "none",
        borderColor: stitches_config_1.colors.borderUiFocused,
    },
};
exports.Input = (0, stitches_config_1.styled)("input", {
    ...exports.InputStyles,
    variants: {
        size: exports.sizeVariants,
        error: exports.errorVariant,
        prefixed: {
            true: {
                paddingLeft: "20px",
            },
        },
        postfixed: {
            true: {
                paddingRight: "20px",
            },
        },
        isDisabled: {
            true: {
                backgroundColor: stitches_config_1.colors.bgUiContainer,
                color: stitches_config_1.colors.contentDisabled,
            },
        },
        isReadonly: {
            true: {
                backgroundColor: stitches_config_1.colors.bgUiContainer,
                color: stitches_config_1.colors.contentPrimary,
            },
        },
    },
    compoundVariants: [
        {
            size: "smaller",
            prefixed: true,
            css: {
                paddingLeft: "18px",
            },
        },
        {
            size: "small",
            prefixed: true,
            css: {
                paddingLeft: "20px",
            },
        },
        {
            size: "medium",
            prefixed: true,
            css: {
                paddingLeft: "20px",
            },
        },
        {
            size: "large",
            prefixed: true,
            css: {
                paddingLeft: "22px",
            },
        },
        {
            size: "smaller",
            postfixed: true,
            css: {
                paddingRight: "24px",
            },
        },
        {
            size: "small",
            postfixed: true,
            css: {
                paddingRight: "24px",
            },
        },
        {
            size: "medium",
            postfixed: true,
            css: {
                paddingRight: "32px",
            },
        },
        {
            size: "large",
            postfixed: true,
            css: {
                paddingRight: "32px",
            },
        },
    ],
});
exports.InputWrapper = (0, stitches_config_1.styled)("div", {
    position: "relative",
    height: "100%",
    width: "100%",
    display: "grid",
});
exports.Symbol = (0, stitches_config_1.styled)("span", {
    position: "absolute",
    height: "100% ",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: "8px",
    fontSize: stitches_config_1.fontSizes.body3,
    color: stitches_config_1.colors.contentSecondary,
    "@media print": {
        display: "none",
    },
    variants: {
        // make sure the symbol is the same size as the input text
        size: (0, lodash_1.mapValues)(exports.sizeVariants, ({ fontSize, lineHeight, padding }) => ({
            padding,
            fontSize,
            lineHeight,
        })),
        postfix: {
            true: {
                justifySelf: "flex-end",
            },
        },
        prefix: {
            true: {
                justifySelf: "flex-start",
            },
        },
    },
});
exports.TextareaInput = (0, stitches_config_1.styled)(react_textarea_autosize_1.default, {
    ...exports.InputStyles,
    resize: "vertical",
    "@media print": {
        display: "none",
    },
    variants: {
        error: exports.errorVariant,
        size: {
            smaller: {
                fontSize: "12px",
            },
            small: {
                padding: "6px 8px",
                fontSize: "14px",
                lineHeight: "20px",
            },
            medium: {
                padding: "8px",
                fontSize: "16px",
                lineHeight: "22px",
            },
        },
        isDisabled: {
            true: {
                backgroundColor: stitches_config_1.colors.bgUiContainer,
                color: stitches_config_1.colors.contentDisabled,
            },
        },
        isReadonly: {
            true: {
                backgroundColor: stitches_config_1.colors.bgUiContainer,
                color: stitches_config_1.colors.contentPrimary,
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,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